import {
  attr,
  classNames,
  css,
  customElement,
  GenesisElement,
  html,
  observable,
  volatile,
  when,
} from '@genesislcap/web-core';
import { BondSeries } from './deal-detail.types';
import {
  MaturityStatusColor,
  MaturityOrder,
  OrderStatusEnum,
} from '../deal-series/deal-series.types';
import { seriesSizeFormatter } from '../deal-series/deal-series.util';

@customElement({
  name: 'deal-series-tab-info',
  template: html<DealSeriesTabInfoComponent>`
    <div class="series-tab-info">
      <div
        class="series-tab-info-label ${(x) =>
          classNames(['series-tab-info-label-active', x.isActive])}"
      >
        ${(x) => seriesSizeFormatter(x.bondSeries?.SERIES_CODE || '', x.bondSeries?.SERIES_SIZE)}
      </div>
      ${when(
        (x) => x.submittedOrdersCount,
        html<DealSeriesTabInfoComponent>`
          <div class="series-tab-info-icon">
            ${(x) => x.submittedOrdersCount}
            <rapid-icon
              style="color: ${() => MaturityStatusColor[OrderStatusEnum.SUBMITTED]}"
              name="circle-check"
            ></rapid-icon>
          </div>
        `,
      )}
      ${when(
        (x) => x.pendingOrdersCount,
        html<DealSeriesTabInfoComponent>`
          <div class="series-tab-info-icon">
            ${(x) => x.pendingOrdersCount}
            <rapid-icon
              style="color: ${() => MaturityStatusColor[OrderStatusEnum.DRAFT]}"
              name="circle-exclamation"
            ></rapid-icon>
          </div>
        `,
      )}
    </div>
  `,
  styles: css`
    :host {
      display: block;
      color: var(--neutral-foreground-rest);
    }

    .series-tab-info {
      display: flex;
      align-items: center;
      padding: 10px;
      gap: 5px;
    }

    .series-tab-info-label {
      max-width: 400px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .series-tab-info-label-active {
      max-width: none;
    }
  `,
})
export class DealSeriesTabInfoComponent extends GenesisElement {
  @attr({ attribute: 'is-active', mode: 'boolean' }) isActive: boolean;

  @volatile get pendingOrdersCount(): number {
    return this.getOrdersForStatus(OrderStatusEnum.DRAFT);
  }

  @volatile get submittedOrdersCount(): number {
    return this.getOrdersForStatus(OrderStatusEnum.SUBMITTED);
  }

  @observable bondSeries: BondSeries;

  @observable munisOrders: MaturityOrder[];

  private getOrdersForStatus(status: OrderStatusEnum): number {
    if (!this.munisOrders) {
      return null;
    }
    return this.munisOrders.filter((o) => o.ORDER_STATUS === status).length;
  }
}
